import { FeedItem } from '@knocklabs/client'
import { useKnockFeed } from '@knocklabs/react-notification-feed'
import React from 'react'
import { useCallback, useEffect } from 'react'
import { useUiContext } from 'modules/UiContext'
import { Clap } from './icons/Clap'
import { Generic } from './icons/Generic'
import { Learn } from './icons/Learn'
import { Love } from './icons/Love'
import { Reply } from './icons/Reply'
import { Supertester } from './icons/Supertester'

const reactionIcons = {
  Love: <Love />,
  Reply: <Reply />,
  Learn: <Learn />,
  Thank: <Clap />
}

const getIconForNotificationKey = (item: FeedItem): React.ReactNode | null => {
  switch (item.source.key) {
    case 'new-review-reply':
      return reactionIcons[item.data?.replyType as keyof typeof reactionIcons]
    case 'new-review':
      return <Generic />
    case 'new-review-clap':
      return <Clap />
    case 'new-achievement':
      return <Supertester />
    default:
      return null
  }
}

export const NotificationToaster = () => {
  const { feedClient } = useKnockFeed()
  const { addNotification } = useUiContext()

  const onNotificationsReceived = useCallback(
    ({ items }: { items: FeedItem[] }) => {
      // Whenever we receive a new notification from our real-time stream, show a toast
      // (note here that we can receive > 1 items in a batch)
      items.forEach((notification) => {
        // Strip html tags from the notification
        const div = document.createElement('div')
        div.innerHTML = notification.blocks[0].rendered

        const icon = getIconForNotificationKey(notification)
        addNotification('default', div.textContent, icon, 5000)
      })

      // Optionally, you may want to mark them as "seen" as well
      // feedClient.markAsSeen(items)
    },
    [addNotification]
  )

  useEffect(() => {
    // Receive all real-time notifications on our feed
    feedClient.on('items.received.realtime', onNotificationsReceived)

    // Cleanup
    return () => feedClient.off('items.received.realtime', onNotificationsReceived)
  }, [feedClient, onNotificationsReceived])

  return null
}
